import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useHoverOverlay } from "./HoverOverlayProvider";
export default function HoverTooltip({ onOpen, onClose, PopperProps, useOverlay = true, ...props }) {
    const { show, hide } = useHoverOverlay();
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = useCallback((e) => {
        if (useOverlay) {
            show();
            setIsOpen(true);
        }
        onOpen?.(e);
    }, [show, onOpen, useOverlay]);
    const handleClose = useCallback((e) => {
        if (useOverlay && isOpen) {
            hide();
            setIsOpen(false);
        }
        onClose?.(e);
    }, [hide, onClose, useOverlay, isOpen]);
    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (useOverlay && isOpen) {
                hide();
            }
        };
    }, [hide, useOverlay, isOpen]);
    return (_jsx(Tooltip, { ...props, arrow: true, onOpen: handleOpen, onClose: handleClose, PopperProps: {
            ...PopperProps,
            sx: {
                zIndex: 1400,
                "& .MuiTooltip-tooltip": {
                    background: "#0B0F19",
                    borderRadius: "8px",
                    padding: "10px 14px",
                },
                "& .MuiTooltip-arrow": {
                    color: "#0B0F19",
                },
                ...PopperProps?.sx,
            },
        } }));
}
